<template>
  <div>
    <div v-loading="loading" class="sidebar-stage" :style="stageHeight ? { height: `${stageHeight}px` } : null"
      element-loading-text="加载中...">
      <div class="headers">
        <div class="header">律师及律所广告位</div>
        <div class="header">当事人案件预委托信息（已脱敏）</div>
      </div>

      <div class="content">
        <div v-for="row in rows" :key="row.id" class="row">
          <div v-for="cell in row.cells" :key="cell.id" class="item">
            <div v-if="cell.type === 'card'" class="card" @click="handleCardPreview(cell)">
              <div class="code">编号：{{ cell.subtitle }}</div>
              <el-image :src="cell.banner" fit="cover" class="media image" />
              <div v-if="cell.video" class="overlay">
                <img :src="playIcon" alt="播放" class="play" />
              </div>
            </div>

            <div v-else class="empty-item" />
          </div>
        </div>
      </div>
    </div>

    <SidebarMediaDialog :visible="previewVisible" :title="previewItem.subtitle ? `编号：${previewItem.subtitle}` : ''"
      :image-src="previewItem.banner" :video-src="previewItem.video" @close="handlePreviewClose" />
  </div>
</template>

<script>
import SidebarMediaDialog from "./SidebarMediaDialog.vue";

const LAWYER_COLUMN_ID = 5;
const ENTRUST_COLUMN_ID = 6;

export default {
  name: "SidebarStage",
  components: {
    SidebarMediaDialog,
  },
  props: {
    stageHeight: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      playIcon: require("../../../assets/home-confirm/base/play-icon.svg"),
      loading: false,
      rows: [],
      previewVisible: false,
      previewItem: {},
    };
  },
  mounted() {
    this.fetchRows();
  },
  methods: {
    buildCardItem(item, index, prefix) {
      if (!item.banner && !item.video) {
        return null;
      }

      return {
        id: `${prefix}-${index}`,
        type: "card",
        ...item,
      };
    },
    extractColumnItems(data, prefix) {
      if (!Array.isArray(data)) {
        return [];
      }

      return data
        .flatMap((group) => (Array.isArray(group.txts) ? group.txts : []))
        .map((item, index) => this.buildCardItem(item, index, prefix))
        .filter(Boolean);
    },
    createEmptyItem(prefix, index) {
      return {
        id: `${prefix}-empty-${index}`,
        type: "empty",
      };
    },
    buildRows(leftItems = [], rightItems = []) {
      const rowCount = Math.max(leftItems.length, rightItems.length);

      this.rows = Array.from({ length: rowCount }, (_, index) => ({
        id: `row-${index + 1}`,
        cells: [
          leftItems[index] || this.createEmptyItem("law", index),
          rightItems[index] || this.createEmptyItem("entrust", index),
        ],
      }));
    },
    async fetchColumnItems(columnId, prefix) {
      const res = await this.$api({
        url: "Lunbo",
        method: "get",
        data: {
          nav_id: columnId,
        },
      });

      if (res.code !== 200) {
        this.$message.error(res.msg || "轮播图获取失败");
        return [];
      }

      return this.extractColumnItems(res.data, prefix);
    },
    async fetchRows() {
      this.loading = true;

      try {
        const [lawyerItems, entrustItems] = await Promise.all([
          this.fetchColumnItems(LAWYER_COLUMN_ID, "law"),
          this.fetchColumnItems(ENTRUST_COLUMN_ID, "entrust"),
        ]);

        this.buildRows(lawyerItems, entrustItems);
      } catch (error) {
        this.rows = [];
        this.$message.error("轮播图获取失败，请稍后重试");
      } finally {
        this.loading = false;
      }
    },
    handleCardPreview(cell) {
      if (cell && cell.link) {
        window.open(cell.link, "_blank");
      } else {
        this.previewItem = cell;
        this.previewVisible = true;
      }
    },
    handlePreviewClose() {
      this.previewVisible = false;
      this.previewItem = {};
    },
  },
};
</script>

<style scoped>
.sidebar-stage {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 720px;
  height: 100%;
}

.sidebar-stage::after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 50%;
  z-index: 4;
  width: 2px;
  background: #ffffff;
  transform: translateX(-50%);
  pointer-events: none;
}

.headers {
  display: grid;
  grid-template-columns: repeat(2, 360px);
}

.content {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
}

/* 滚动条 */
.content::-webkit-scrollbar {
  width: 8px;
}

.content::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.content::-webkit-scrollbar-thumb {
  background: #000000;
  border-radius: 4px;
}

.content::-webkit-scrollbar-thumb:hover {
  background: #333333;
}

/* 滚动条 */

.row {
  display: grid;
  grid-template-columns: repeat(2, 360px);
}

.header {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 84px;
  background: #d92f24;
  color: #ffffff;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  white-space: nowrap;
}

.item {
  width: 360px;
  height: 199px;
}

.card {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  cursor: pointer;
}

.code {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 91px;
  height: 27px;
  background: rgba(0, 0, 0, 0.25);
  border-radius: 0 0 6px 0;
  color: #ffffff;
  font-size: 16px;
  padding: 8px;
}

.media {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.28);
}

.play {
  width: 60px;
  height: 60px;
}

.empty-item {
  width: 100%;
  height: 100%;
  background: #ffffff;
}
</style>
